import { usePlatformStore } from '@/shared/stores/platform'

interface FormatPriceOps {
  amount: number | string
  currency?: string | null
  hideDecimals?: boolean
}

export const formatPrice = (opts: FormatPriceOps) => {
  const platformStore = usePlatformStore()
  let locale = platformStore.locale

  try {
    new Intl.NumberFormat(locale)
  } catch (error) {
    locale = 'en-US'
  }

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: opts.currency || 'USD',
    maximumFractionDigits: opts.hideDecimals ? 0 : 2,
    currencyDisplay: 'narrowSymbol',
  }).format(Number(opts.amount || 0))
}
